import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import { GetData } from "../../SendingData";
import { Loading } from "../Loading";
import { Link } from "react-router-dom";

const Style = styled.div`
    @keyframes fade-in-anim {
        0% {
            opacity: 0;
        }
        100%  {
            opacity: 1;
        }
    }
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 90px 0;
    padding: 0 60px;
    width: calc(100% - 140px);
    .blog-type{
        width: calc(100% - 2rem);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: center;
        text-decoration:none;
        font-size: 1.5rem;
        font-weight: 500;
        padding: 1rem;
        border-radius: var(--border-radius-2);
        margin-bottom: 1rem;
        overflow: hidden;
        animation: fade-in-anim1 0.8s ease-in-out 1 0s forwards;
        .top-type{
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            color: var(--prime-2);
            margin-bottom: 0.5rem;
            .more-btn{
                position: relative;
                font-size: 1rem;
                font-weight: 300;
                color: var(--prime-2);
                text-decoration: none;
            }
            .name-type{
                color: var(--prime-2);
                font-weight: 500;
            }
        }
        .blog-data{
            width: 100%;
            position: relative;
            display: grid;
            grid-template-columns: repeat(3 , calc(calc(100% / 3) - calc(2rem / 3)));
            grid-gap: 1rem;
            overflow: hidden;
            .blog{
                border-radius: var(--border-radius-1);
                position: relative;
                width: 100%;
                display: flex;
                text-decoration: none;

                .bl-img{
                    position: relative;
                    width: 100%;
                    aspect-ratio: 1.5;
                    object-fit: fill;
                    border-radius:var(--border-radius-1) ;
                }
                .bl-name{
                    display: flex;
                    position: absolute;
                    bottom: 1rem;
                    left: 0.5rem;
                    color: var(--text-3);
                }
                :hover{
                    box-shadow: var(--n-shadow-4);
                    cursor: pointer;
                }
            }
        }
        
        
    }
    @media screen and (max-width: 850px ){
        margin: 10px 0;
        padding: 0 ;
        width:100%;
        .blog-type .blog-data{
            grid-template-columns: 1fr;
        }

    }
`
const LotusPage =(data)=>{
    const [all , setAll ] = useState([])
    const [loadingB , setLoadingB ] = useState(true)
    const [error , setError ] = useState('')
    const lang = localStorage.getItem('lang') 
    useEffect(()=>{
        getBlogData()
    },[localStorage.getItem('lang')])


    const getBlogData=()=>{
        GetData(`https://lotusapi.farazandishan.com/api/v1/blog/bm?en_fa=${lang}` ,'' , processGetData)
    }
    const processGetData=(obj , datas)=>{
        let response = JSON.parse(datas)
        if(response.status === 'success'){
            setLoadingB(false)
            allType(response.data)
        }else{
            setError(response.data.message)
        }
    }
    const allType =(bd)=>{
        let all = []
        for(let b of bd){
            !all[b.BType_Id]  ? all[b.BType_Id]=[b] : all[b.BType_Id].push(b)
        }
        setAll(all)
    }
    const showBlogs=()=>{
        if(all.length){
            let blogs = []
            if(all.length > 4){
                all.map((b)=> blogs.push(b[0]))
            }else{
                blogs = all
            }
            let types = blogs.map((type , index)=>{
                return (
                    <Link className="blog" to={"/" + data.language.filename + '/lotus-all-blog'} key={index}>
                        <img src={type.BM_Image} alt={type.Btype_Name} className="bl-img"/>
                        <span className="bl-name">{type.Btype_Name}</span>
                    </Link>
                )
            })
            return types
        }
        else{
            return 
        }
    }
    if(loadingB){
        return <Style><Loading/></Style>
    }else{        
        return(
            <Style>
                 <div className="blog-type">
                    <div className="top-type">
                        <span className="name-type">{data.data.data.blogs}</span>
                        <Link to={"/" + data.language.filename + '/lotus-all-blog'} className="more-btn">{data.data.data.more}</Link>
                    </div>
                    <div className="blog-data">
                        {showBlogs()}
                    </div>

                </div>
            </Style>
        )
     }
}
export default LotusPage